import { render, staticRenderFns } from "./previewCertificate.vue?vue&type=template&id=f6c99062&scoped=true"
import script from "./previewCertificate.vue?vue&type=script&lang=js"
export * from "./previewCertificate.vue?vue&type=script&lang=js"
import style0 from "./previewCertificate.vue?vue&type=style&index=0&id=f6c99062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c99062",
  null
  
)

export default component.exports